<template>
  <div class="p-search-wrap">
    <div class="p-search-tab">
        <ul>
            <li :class="{active: currentType === 'case'}" @click="switchTab('case')"><em class="ibass ibass-case"></em>案例</li>
            <li :class="{active: currentType === 'law'}" @click="switchTab('law')"><em class="ibass ibass-regulation"></em>法规</li>
            <li :class="{active: currentType === 'judicialView'}" class="p-search-excellent-case" @click="switchTab('judicialView')"><em class="ibass ibass-judicial"></em>司法观点
              <div class="library-is-new">NEW</div>
            </li>
            <li class="p-search-excellent-case" @click="switchTab('similarityCase')"><em class="ibass ibass-case-compilation-rules"></em>类案同判
              <div class="library-is-new">NEW</div>
            </li>
            <li class="p-search-excellent-case" @click="switchTab('excellentCase')"><em class="ibass ibass-excellent-case"></em>优案评析
              <!-- <div class="library-is-new">NEW</div> -->
            </li>
            <li :class="{active: currentType === 'article'}" class="p-search-excellent-case" @click="switchTab('article')">
              <em class="ibass-article">
                <svg width="21px" height="22px" viewBox="0 0 21 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>形状结合</title>
                    <g id="Alpha组件规范" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="首页-2" transform="translate(-797.000000, -259.000000)" fill="#ED6C00">
                            <g id="编组-10" transform="translate(325.000000, 244.000000)">
                                <g id="编组-5" transform="translate(21.000000, 0.000000)">
                                    <g id="编组-6" transform="translate(420.000000, 0.000000)">
                                        <g id="编组-2" transform="translate(31.000000, 15.000000)">
                                            <path d="M15.9115552,11.3905387 C17.3814568,11.5139768 18.653412,12.0618922 19.6790098,13.1115749 C20.2827194,13.7295069 20.6899287,14.4577068 20.8852359,15.292185 C20.9852757,15.7196989 21.020418,16.1531092 20.9886742,16.5936518 C20.9180281,17.5742714 20.550155,18.4368904 19.9221856,19.1958793 C19.7544644,19.3985847 19.5570603,19.5781631 19.3687309,19.7639911 C19.3228869,19.809327 19.3003987,19.8510615 19.3006518,19.9159936 L19.3023014,20.904381 L19.3023014,20.904381 L19.3021341,22 C19.264208,21.9808629 19.2381405,21.9685402 19.2128684,21.9549112 C18.6074595,21.6287677 18.0015806,21.3034363 17.3975818,20.9748919 C17.3294304,20.9378181 17.271583,20.9314979 17.1958029,20.9538834 C16.8078278,21.0682825 16.411718,21.1407353 16.0074372,21.1791155 C15.6010594,21.2177429 15.1955855,21.216154 14.7917385,21.1725129 C13.7000502,21.054477 12.7072447,20.6863518 11.8332071,20.0287686 C10.9702689,19.3795888 10.3548091,18.5569389 10.0599321,17.5290767 C9.66736538,16.1607358 9.89228319,14.875864 10.712342,13.7074038 C11.5463926,12.5190297 12.7240204,11.8196061 14.1534651,11.5082215 C14.7332404,11.3819234 15.320825,11.3409304 15.9115552,11.3905387 Z M15.1734769,0.000546846592 C15.2845439,0.000546846592 15.3962978,0.00517224406 15.5066416,0.0173536343 C16.0203263,0.0742001223 16.45335,0.292723672 16.8108468,0.654104917 C17.1460361,0.992994725 17.3390656,1.40034748 17.3995161,1.86648868 C17.4134717,1.97400269 17.412134,2.08384705 17.412134,2.19259686 L17.4126476,10.0980014 C17.2411227,10.0624105 17.0834525,10.0286557 16.9252761,9.99709003 C16.2638276,9.86510732 15.5964135,9.83241176 14.9231786,9.87372256 C14.1888424,9.91881136 13.4759097,10.0619515 12.789406,10.317796 C11.034823,10.9716719 9.70784046,12.0930306 8.89425335,13.7612809 C8.61069278,14.3427039 8.43574064,14.9581642 8.36462452,15.6001412 C8.18656309,17.20812 8.61159664,18.6545983 9.58621637,19.9540525 C9.59652043,19.9677875 9.60581216,19.9822286 9.62511872,20.0104126 L9.5271759,20.0104126 C7.08077445,20.0104126 4.634373,20.0107931 2.18800771,20.0099457 C1.10821423,20.0095926 0.214327744,19.2766613 0.0298307877,18.2389481 C0.00839110602,18.1181581 0.00412486246,17.9932371 0.00412486246,17.870258 C0.00289560584,12.6271052 0.0065833757,7.38395231 1.61658772e-06,2.14083477 C-0.0012621739,1.11886909 0.738605693,0.240361348 1.72002249,0.047330447 C1.88955143,0.0139993385 2.06616669,0.00185325656 2.23952803,0.00174733143 C6.55082023,-0.000653638248 10.8621486,-7.76947607e-05 15.1734769,0.000546846592 Z M17.4216608,14.3608907 C16.8507434,14.3614209 16.3913991,14.8121676 16.3917243,15.3715936 C16.3920137,15.9281595 16.8571427,16.3827196 17.4251678,16.381627 C17.9901196,16.3806011 18.4618649,15.9184497 18.4599546,15.3680274 C18.4579602,14.813121 17.9912404,14.3603263 17.4216608,14.3608907 Z M13.322343,14.3608912 C12.751281,14.3607853 12.288719,14.8119558 12.2885743,15.3691926 C12.2884659,15.9256526 12.7530164,16.3812719 13.320933,16.3816253 C13.8859933,16.3820134 14.3571963,15.9224396 14.3577753,15.3703931 C14.3583171,14.8161222 13.891525,14.3609972 13.322343,14.3608912 Z M7.2189212,10.5204308 C6.62576873,10.5233967 6.0325801,10.5213135 5.43942762,10.5213135 L5.43942762,10.528234 C4.80119036,10.528234 4.16280847,10.5209251 3.52475198,10.5310586 C3.15926506,10.5368845 2.84938393,10.7868325 2.74496942,11.1245925 C2.63849411,11.4688844 2.76116669,11.8369037 3.05231973,12.0532734 C3.23070656,12.1858564 3.43483547,12.2296741 3.65382392,12.2296035 C4.82208772,12.2291444 5.99038767,12.2295681 7.15865147,12.2289679 C7.23374459,12.2288973 7.30927156,12.2266022 7.38385851,12.2186225 C7.728665,12.1818665 7.97281705,12.004336 8.10373288,11.69394 C8.23678184,11.378495 8.18103143,11.0819046 7.95853598,10.8207639 C7.7675312,10.5966263 7.51072503,10.5189479 7.2189212,10.5204308 Z M8.70534554,6.83211768 L3.75299601,6.83240014 L3.75299601,6.83240014 C3.67775827,6.83240014 3.60244823,6.83490704 3.52731895,6.83893219 C2.9680795,6.86905024 2.58686533,7.39341496 2.74160705,7.91898016 C2.85480712,8.30327654 3.19079188,8.53948959 3.63437274,8.5395602 L13.7830431,8.53924243 L13.7830431,8.53924243 C13.8550269,8.53920712 13.9282038,8.53486419 13.9987776,8.52190601 C14.3735924,8.45305468 14.6779057,8.12970056 14.7027801,7.77834689 C14.7327884,7.35503475 14.5005674,6.99630163 14.1035898,6.87876004 C13.9823634,6.84288673 13.8488445,6.83420087 13.7209295,6.83398902 C12.0491043,6.83116435 10.3772068,6.83211768 8.70534554,6.83211768 Z M9.57800927,3.14275854 L7.62157505,3.14292184 C6.4618799,3.14292184 5.30218474,3.14260406 4.14245343,3.14320431 C3.93770989,3.14331023 3.73264096,3.14059149 3.52825897,3.15051314 C3.19259961,3.16675499 2.94642289,3.33002093 2.79865901,3.62142097 C2.64879817,3.91702271 2.67439563,4.21008225 2.86474963,4.48139182 C3.0524282,4.7489234 3.32687781,4.85103522 3.65136541,4.85092938 L11.58553,4.85004659 L11.58553,4.85004659 C11.6365441,4.85004659 11.6877029,4.84527996 11.7385362,4.84033679 C12.1723554,4.79814328 12.4956137,4.4804738 12.5273574,4.04561582 C12.555775,3.65704713 12.3015358,3.28874544 11.9003643,3.18172575 C11.7834764,3.15054845 11.6566822,3.14472257 11.5344435,3.14447541 L9.57800927,3.14275854 L9.57800927,3.14275854 Z" id="形状结合"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </svg></em>实务文章
              <!-- <div class="library-is-new">NEW</div> -->
            </li>
            <li :class="{active: currentType === 'subjectAnalysis'}" class="p-search-excellent-case" @click="switchTab('subjectAnalysis')">
              <em class="ibass-article">
                <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                  <title>编组 70</title>
                  <g id="主体专业库-3.0" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g id="大数据-主体库功能入口上调" transform="translate(-838, -254)" fill="#ED6C00">
                          <g id="工具-功能卡片" transform="translate(140, 144)">
                              <g id="编组-10" transform="translate(143, 96)">
                                  <g id="编组-5" transform="translate(21, 0)">
                                      <g id="编组-6备份" transform="translate(504, 0)">
                                          <g id="编组-70" transform="translate(30, 14)">
                                              <g id="编组" transform="translate(1.5, 2)" fill="#B7A598">
                                                  <path d="M13.0182619,1.88475215 C13.0890552,2.12536243 13.125,2.3748767 13.125,2.6256854 L13.124,5.185 L13.125,5.186 L13.125,20.999 L1.575,21 C0.705151517,21 -3.37563494e-16,20.2948485 -4.4408921e-16,19.425 L4.4408921e-16,4.94269994 C3.01494121e-16,3.77832268 0.767035551,2.75309552 1.88406674,2.42443806 L9.75906675,0.107423524 C11.1498644,-0.301782613 12.6090557,0.493954516 13.0182619,1.88475215 Z M15.093,6.564 L19.8811083,9.91833655 C20.5323013,10.374519 20.9388945,11.0989943 20.9936569,11.8857184 L21,12.0682813 L21,19.425 C21,20.2948485 20.2948485,21 19.425,21 L15.093,20.999 L15.093,6.564 Z M6.71649273,11.9893879 L3.78350727,11.9893879 C3.14368137,11.9893879 2.625,12.5080693 2.625,13.1478952 C2.625,13.7877211 3.14368137,14.3064025 3.78350727,14.3064025 L6.71649273,14.3064025 C7.35631863,14.3064025 7.875,13.7877211 7.875,13.1478952 C7.875,12.5080693 7.35631863,11.9893879 6.71649273,11.9893879 Z M8.02899273,6.84046673 L3.78350727,6.84046673 C3.14368137,6.84046673 2.625,7.3591481 2.625,7.998974 C2.625,8.6387999 3.14368137,9.15748127 3.78350727,9.15748127 L8.02899273,9.15748127 C8.66881863,9.15748127 9.1875,8.6387999 9.1875,7.998974 C9.1875,7.3591481 8.66881863,6.84046673 8.02899273,6.84046673 Z" id="形状结合"></path>
                                              </g>
                                          </g>
                                      </g>
                                  </g>
                              </g>
                          </g>
                      </g>
                  </g>
              </svg></em>公司主体
              <div class="library-is-new">NEW</div>
            </li>
            <li @click="switchTab('more')"><em class="ibass ibass-database"></em>更多</li>
        </ul>
    </div>

    <div class="p-search-input_container">
      <div class="p-search-input" :class="{'border-radius-change': suggestQueryArray.length > 0}">
        <div v-show="suggestQueryArray.length > 0" class="p-search-input_suggest">
          <ul class="clearfix">
            <li v-for="(item, index) in suggestQueryArray" :key="index">
                <span class="ellipsis" :title="`${item.value}`">{{item.name}}:{{item.value}}</span>
                <i @click="deleteSuggest(index)" class="ibass ibass-close"></i>
            </li>
          </ul>
        </div>

        <div :class="['p-search-input_wrap',{'p-search-input_wrap_search_border': suggestQueryArray.length > 0}]">
          <em :class="['ibass ibass-search',{'search-btn_bottom': suggestQueryArray.length > 0}]"></em>
          <input id="search_input" type="text" v-model.trim="searchVal" autocomplete="off" :placeholder="placeholderVal" v-on:keyup.enter="goSearch" @focus="searchFocus" @input="searchInput" maxlength="500">
          <div :class="['p-search-input-btn',{'p-search-input-btn_bottom': suggestQueryArray.length > 0}]" @click="goSearch"><em class="ibass ibass-search"></em></div>
          <!-- <div class="search-module-i-close" @click="clearModel" :class="{'search-module-i-close-advance':currentType !=='otherDB' && currentType !=='excellentCase','search-module-i-close-not-advance':currentType =='otherDB' || currentType =='excellentCase'}">
            <div class="i-close-module">
              <i class="ibass-close"></i>
            </div>
          </div> -->
          <i v-if="this.searchVal.trim()" class="el-icon-circle-close search-module-i-close" @click="clearModel"></i>
        </div>
      </div>
      <search-history class="children-component-class" name="历史搜索记录组件" v-show="isShowHistoryList" :searchHistoryData="searchHistoryData" :currentType="currentType" @clearHistorySearch="clearHistorySearch" @searchHistoryItemClickCallBack="searchHistoryItemClickCallBack"></search-history>
      <component class="children-component-class" :is="currentSearchSuggestComponent" name="搜索联想组件" v-show="isShowSuggestList && isHasSearchSuggestData && searchVal.trim()" :currentType="currentType" :searchVal="searchVal" @searchSuggestItemClickCallBack="searchSuggestItemClickCallBack" @isShowSearchSuggest="isShowSearchSuggest"></component>
    </div>

    <div class="p-search-btn-wrap">
        <ul>
            <li>更多数据库：</li>
            <li @click="goAdministration">行政处罚</li>
            <li @click="goCheckDocument">检察文书</li>
            <li @click="goLogoReview">商标评审</li>
            <li @click="goSmartSearch">
              <div class="p-icon ibass ibass-dot"></div>
              智慧检索
            </li>
        </ul>
    </div>
  </div>
</template>
<script>
import searchHistory from './components/searchHistory'
import searchSuggestCase from './components/searchSuggestCase'
import searchSuggestJudicialView from './components/searchSuggestJudicialView'
import searchSuggestLaw from './components/searchSuggestLaw'
import searchSuggestArticle from './components/searchSuggestArticle'
import indexService from '../../service/index'
export default {
  name: 'PDataBaseSearch',
  components: {
    searchHistory,
    searchSuggestCase,
    searchSuggestJudicialView,
    searchSuggestLaw,
    searchSuggestArticle
  },
  data () {
    return {
      placeholderVal: '在Alpha案例库中检索',
      currentType: 'case', // 当前选中的类型
      searchVal: '',
      isShowHistoryList: false, // 是否展示检索历史记录
      isShowSuggestList: false, // 是否展示搜索联想列表
      currentSearchSuggestComponent: 'searchSuggestCase', // 当前搜索联想组件，默认显示案例搜索联想组件
      isHasSearchSuggestData: true, // 搜索联想是否有数据
      suggestQueryArray: [], // 案例搜索联想数据集合
      judicialViewGoSearch: '',
      searchHistoryData: [],
      Domain: process.env.VUE_APP_IFRAME_DOMAIN,
      subjectAnalysisDomain: process.env.VUE_APP_IFRAME_SUBJECT_ANALYSIS_DOMAIN,
    }
  },
  computed: {
  },
  mounted () {
    let _this = this
    window.addEventListener('click', _this.listenerEvent, false)
    window.addEventListener('message', function (e) {
      if (e.data.type === 'clickDocument') {
        _this.searchBlur()
      }
    }, false)
    this.getHistoryList('case')
  },
  watch: {
    suggestQueryArray: function (value) {
      if (Array.isArray(value) && value.length === 0 && this.judicialViewGoSearch) {
        this.judicialViewGoSearch = ''
      }
    }
  },
  methods: {
    switchTab (type) {
      switch (type) {
        case 'case':
          this.placeholderVal = '在Alpha案例库中检索'
          this.currentType = 'case'
          this.currentSearchSuggestComponent = 'searchSuggestCase'
          break
        case 'law':
          this.placeholderVal = '在Alpha法规库中检索'
          this.currentType = 'law'
          this.currentSearchSuggestComponent = 'searchSuggestLaw'
          this.suggestQueryArray = []
          break
        case 'judicialView':
          this.placeholderVal = '在Alpha司法观点库中检索'
          this.currentType = 'judicialView'
          this.currentSearchSuggestComponent = 'searchSuggestJudicialView'
          this.suggestQueryArray = []
          break
        case 'similarityCase':
          this.currentType = 'case'
          this.suggestQueryArray = []
          this.$analysis.track('点击类案同判_大数据检索/工作台模块')
          window.open(this.Domain + '/#/app/tool/search/case?searchType=similarityCase&keyword=' + this.searchVal.trim())
          break
        case 'excellentCase':
          this.currentType = 'case'
          this.suggestQueryArray = []
          this.$analysis.track('检索案例评析_大数据检索/工作台模块')
          window.open(this.Domain + '/#/app/tool/search/case?searchType=excellentCase&keyword=' + this.searchVal.trim())
          break
        case 'article':
          this.placeholderVal = '在Alpha实务文章库中检索'
          this.currentType = 'article'
          this.currentSearchSuggestComponent = 'searchSuggestArticle'
          this.suggestQueryArray = []
          break
        case 'subjectAnalysis':
          this.currentType = 'case'
          this.suggestQueryArray = []
          this.$analysis.track('公司主体_大数据检索/工作台模块')
          window.open(this.subjectAnalysisDomain + '/#/industry/subject-analysis/list')
          break
        case 'more':
          this.currentType = 'case'
          this.suggestQueryArray = []
          this.$analysis.track('点击更多_大数据检索/工作台模块')
          // 跳转到工具-大数据-更多页面
          window.open(this.Domain + '/#/app/tool/search/case?searchType=otherDB&keyword=' + this.searchVal.trim())
      }
      this.getHistoryList(type)
    },
    // 输入框获取光标
    searchFocus () {
      // 改变currentType值，更新历史记录数据
      this.changeCurrentType()
      let val = this.searchVal.trim()
      // 历史记录
      if (!val) {
        this.isShowHistoryList = true
      } else {
        this.isShowHistoryList = false
      }

      // 搜索联想
      if (val) {
        this.isShowSuggestList = true
      } else {
        this.isShowSuggestList = false
      }
    },
    clearHistorySearch () {
      // 改变currentType值，更新历史记录数据
      this.changeCurrentType()
      this.searchHistoryData = []
    },
    getHistoryList (type) {
      const filterMap = {
        case: '案例',
        law: '法规',
        judicialView: '司法观点',
        similarityCase: '类案规则',
        excellentCase: '优案评析',
        advSanction: '优案评析',
        article: '实务文章'
      }
      indexService.getHistoryList({ pageIndex: 1, pageSize: 5, position: filterMap[type], type: 1 }).then(res => {
        this.searchHistoryData = res.data.results
        this.searchHistoryData.forEach(function (item) {
          item.queryArray = JSON.parse(item.text)
        })
      })
    },
    // 改变currentType值从而从新获取历史记录数据
    changeCurrentType () {
      let currentType = ''
      // 清空历史搜索
      if (this.currentType === 'case') {
        currentType = 'case'
      } else if (this.currentType === 'law') {
        currentType = 'law'
      } else if (this.currentType === 'judicialView') {
        currentType = 'judicialView'
      } else if (this.currentType === 'article') {
        currentType = 'article'
      }
      this.currentType = ''
      this.currentType = currentType
    },
    listenerEvent (e) {
      if (e.target.id !== 'search_input') {
        this.searchBlur()
      }
    },
    // 输入框失去光标
    searchBlur () {
      // 不显示历史记录
      if (this.isShowHistoryList) {
        this.isShowHistoryList = false
      }
      // 不显示搜索联想
      if (this.isShowSuggestList) {
        this.isShowSuggestList = false
      }
    },
    // 搜索联想列表跳转后的回调
    searchSuggestItemClickCallBack (smartType, item, type) {
      // 只有案例和司法观点才走这个逻辑
      if (item) {
        let query = {}
        let level = ''
        if (item.level) {
          level = item.level
        }
        let value = item.name || item
        // 观点库关键词返回格式为(xxx)， 搜索时需要删除后面的括号
        if (type === 'judicialView' && smartType.name === 'keywords') {
          value = value.substring(0, value.lastIndexOf('（'))
        }
        let seed = 0
        query = {
          desc: smartType.desc,
          selectSign: (new Date().getTime()) + (++seed),
          name: smartType.pre,
          value: value,
          description: value,
          dimension: smartType.name
        }
        if (level) {
          query.level = level
        }
        // 去重
        var isRepeat = false
        this.suggestQueryArray.map((item) => {
          if (item.name === query.name && item.value === query.value) {
            isRepeat = true
          }
        })
        if (!isRepeat) {
          let _this = this
          _this.suggestQueryArray.push(query)
          setTimeout(() => {
            _this.searchVal = ''
          })
        }
      }
      if (type === 'judicialView') {
        // 司法观点搜索联想不直接跳转标示
        this.judicialViewGoSearch = 'judicialView'
      }
      // 失去光标
      this.searchBlur()
    },
    // 是否显示搜索联想框
    isShowSearchSuggest (val) {
      this.isHasSearchSuggestData = val
    },
    // 搜索历史记录列表跳转后的回调
    searchHistoryItemClickCallBack () {
      this.searchBlur()
    },
    // 输入时
    searchInput () {
      if (this.searchVal.trim()) {
        // 输入值时如果有keyword，则不显示搜索历史
        this.isShowHistoryList = false
        this.isShowSuggestList = true
      } else {
        this.isShowSuggestList = false
      }
    },
    goSearch () {
      let _this = this
      // 校验检索次是否有效
      if (_this.checkSpecialChar(_this.searchVal)) {
        return _this.$postMessage.toast({ msg: '请输入有效的检索词' })
      }
      // 如果是案例或者司法观点则保存suggestQueryArray，ilawweb用于搜索
      if (_this.currentType === 'case') {
        let suggestQueryArray = JSON.stringify(_this.suggestQueryArray)
        window.localStorage.setItem('suggestQueryArray', suggestQueryArray)
        _this.$analysis.track('检索案例_大数据检索/工作台模块')
      } else if (_this.currentType === 'law') {
        _this.$analysis.track('检索法规_大数据检索/工作台模块')
      } else if (_this.currentType === 'article') {
        _this.$analysis.track('检索实务文章_大数据检索/工作台模块')
      } else if (_this.currentType === 'judicialView') {
        let suggestQueryArray = JSON.stringify(_this.suggestQueryArray)
        window.localStorage.setItem('suggestQueryArray', suggestQueryArray)
        _this.$analysis.track('检索司法观点_大数据检索/工作台模块')
      }
      // 回车后通知工作台处理搜索事件
      window.parent.postMessage({
        action: 'fromWorkFlatEnterSearch',
        data: { keyword: _this.searchVal.trim(), currentType: _this.currentType, judicialViewGoSearch: this.judicialViewGoSearch }
      }, process.env.VUE_APP_IFRAME_DOMAIN)

      setTimeout(() => {
        // 搜索完销毁
        _this.suggestQueryArray = []
      })
    },
    clearModel () {
      this.searchVal = ''
    },
    checkSpecialChar (keyword) {
      let pattern = /[`~+＋\-_^“”"!！@#＃%％$&*＊()=＝|｜{}':;,《》<>?！￥…….（）——【】‘’：；。、，？\s\\/／]/g
      let status = false
      let removeSpecialChar = keyword.replace(pattern, '')
      if (keyword.length && !removeSpecialChar.length && keyword !== removeSpecialChar) {
        status = true
      }
      return status
    },
    // 行政处罚
    goAdministration () {
      this.$analysis.track('点击行政处罚_大数据检索/工作台模块')
      window.open(this.Domain + '/#/app/tool/atv-sanction/%7B%5B%5D,%7D')
    },
    // 检察文书
    goCheckDocument () {
      this.$analysis.track('点击检察文书_大数据检索/工作台模块')
      window.open(this.Domain + '/#/app/tool/pro-doc/%7B%5B%5D,%7D')
    },
    // 商标评审
    goLogoReview () {
      this.$analysis.track('点击商标评审_大数据检索/工作台模块')
      window.open(this.Domain + '/#/app/tool/trademark/%7B%5B%5D,%7D')
    },
    goSmartSearch () {
      this.$analysis.track('点击智慧检索_大数据检索/工作台模块')
      window.open(this.Domain + '/#/app/smartSearch?source=work-plat')
    },
    deleteSuggest (index) {
      this.suggestQueryArray.splice(index, 1)
    }
  }
}
</script>
<style lang="stylus" scoped>
.p-search-wrap
    max-width 720px
    margin 48px 0 32px
    .p-search-tab
        width 77%
        margin 0 auto
        ul
            display flex
            justify-content space-around
            align-items center

            li
                width 16%
                height 40px
                line-height 40px
                text-align center
                padding-top 20px
                font-size 12px
                color #9E9E9E
                cursor pointer
                position relative
                &:hover
                    color #ED6C00
                em
                    position absolute
                    top 0
                    left 50%
                    transform translateX(-50%)
                    -webkit-transform translateX(-50%)
                    font-size 24px
            .active
                color #ED6C00
                border-bottom 2px solid #ED6C00
                svg
                  g
                    fill: #ed6c00;
            .p-search-excellent-case
              position relative
              &:hover
                svg
                  g
                    fill: #ed6c00;
              .library-is-new
                position absolute
                top -19px
                right 0
                color #fa8919
                font-size 12px
                font-weight 500
                transform scale(0.8)
    .p-search-input_container
      position relative
      .p-search-input
          width 79.8%
          height 46px
          border solid 1px #ddd
          box-shadow inset 0 1px 4px 0 rgba(0, 0, 0, 0.1)
          border-radius 61px
          padding-left 23px
          margin 0 auto
          position relative
          .p-search-input_suggest
            ul
              li
                height: 26px
                float: left
                margin 8px 5px 0 10px
                padding 0 8px 0 10px
                border-radius 20px
                background-color #f8f8f9
                font-size 12px
                display flex
                align-items center
                span
                  max-width 216px
                  display inline-block
                i
                  margin-top 3px
                  color #cdc9c5
                  cursor pointer
          .p-search-input_wrap
            em
              position absolute
              left 20px
              top 50%
              margin-top -13px
              font-size 24px
              color #B2B2B2
            .search-btn_bottom
              top 100%
              margin-top -47px
            input
                width 100%
                height 48px
                border-radius 61px
                border none
                color #4a4a4a
                font-size 14px
                background transparent
                padding-left 30px
                padding-right 86px
                box-sizing border-box
                &:focus
                    outline none
            .p-search-input-btn
                position absolute
                right 3px
                top 50%
                margin-top -21px
                width 60px
                height 42px
                border-radius 21px
                background-color #ed6c00
                cursor pointer
                em
                  left 23px
                  margin-top -10px
                  font-size 16px
                  color #fff
            .p-search-input-btn_bottom
              top 100%
              margin-top -56px
            .search-module-i-close
                position: absolute
                right: 70px
                top: 50%
                transform: translateY(-50%)
                cursor: pointer
                &:hover
                  color: #ed6c00
          .p-search-input_wrap_search_border
            margin 10px 0
      .border-radius-change
        border-radius 8px
        min-height 46px
        height max-content
      .children-component-class
        width 77.8%
        position absolute
        left 50%
        transform translateX(-50%)
        -webkit-transform translateX(-50%)
    .p-search-btn-wrap
      width 60%
      margin 24px auto 0
      ul
        display flex
        justify-content space-around
        align-items center

        li
            width 20%
            line-height 1
            text-align center
            color #8590A6
            font-size 12px
            cursor pointer
            position relative
            &:first-child
              color #666
              cursor default
            &:not(:first-child):hover
              color #ed6c00
            .p-icon
              position absolute
              top -5px
              right 4px
              color #ff1744
.clearfix:before,
.clearfix:after {
  content: "";
  display: table;
}

.clearfix:after {
  clear: both;
}

.library-is-hot
  position absolute
  top -19px
  right 0
  color #fa8919
  font-size 12px
  font-weight 500
  transform scale(0.8)

.ellipsis {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.ibass-article{
	svg{
		g{
      fill: #b4a69a;
		}
	}
}
</style>
